import { render } from "./AboutMe.vue?vue&type=template&id=4dd2ddb0"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"

import "./AboutMe.vue?vue&type=style&index=0&id=4dd2ddb0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__